import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbSelect as ClbSelect_ } from '@celebration/design-system/dist/lib/select';
const events = {
    onClbChange: ClbSelect_.events
        .onClbChange,
};
export const ClbSelect = createComponent({
    tagName: ClbSelect_.tagName,
    elementClass: ClbSelect_,
    react: React,
    events: events,
});
//# sourceMappingURL=index.js.map